import * as React from 'react';
import { CommonActionButton } from './CommonActionButton';
import { FullContainer } from './FullContainer';
import { InformationIcon } from './InformationIcon';

interface IProps {
    header: string;
    subHeader: string;
    buttonText: string;
    infoIconHref?: string;
    onPress(): void;
}

export class EmptyContentOnTabDisplay extends React.Component<IProps> {
    public render() {
        return (
            <FullContainer style={styles.mainContainer}>
                <div style={styles.emptyContainer}>
                    <p style={styles.headerText}>{this.props.header}</p>
                    <p style={styles.subText}>{this.props.subHeader}</p>
                    <div style={styles.actionButtonWrap}>
                        {this.props.infoIconHref &&
                            <InformationIcon
                                link={this.props.infoIconHref}
                                style={styles.infoIcon}/>}
                        <CommonActionButton onClick={() => this.props.onPress()} containerStyle={styles.button} buttonContent={this.props.buttonText} />
                    </div>
                </div>
            </FullContainer>
        );
    }
}

const styles: {[key: string]: React.CSSProperties} = {
    mainContainer: {
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex'
    },
    emptyContainer: {
        width: 500,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: 200
    },
    subText: {
        opacity: 0.5,
        marginBottom: 15
    },
    headerText: {
        fontSize: 28,
        fontWeight: 900,
        textAlign: 'center',
        color: 'black',
        marginBottom: 15
    },
    actionButtonWrap: {
        position: 'relative',
        display: 'flex',
        alignItems: 'center'
    },
    infoIcon: {
        position: 'absolute',
        height: '2em',
        left: '-2.8em'
    },
    button: {
        width: 200,
        height: 65
    }
};



// WEBPACK FOOTER //
// ./src/SharedComponents/EmptyContentOnTabDisplay.tsx